/**
 * Quick task 260810-l18 — author Approve/Reopen hook, shared by the portal
 * (external audience) and the internal task detail slide-over
 * (audience: 'internal', Task 3).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitAuthorReviewExternal } from '../services/api/externalBoard';
import { submitAuthorReview as submitAuthorReviewInternal } from '../services/api/tasks';
import { taskActivityQueryKey } from './useTaskActivity';

export type AuthorReviewAudience = 'internal' | 'external';
export type AuthorReviewDecision = 'approved' | 'reopened';

export interface UseAuthorReviewInput {
  taskId: number;
  projectId: number;
  audience: AuthorReviewAudience;
  decision: AuthorReviewDecision;
  reason?: string;
}

export function useAuthorReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ taskId, audience, decision, reason }: UseAuthorReviewInput) => {
      if (audience === 'external') {
        return submitAuthorReviewExternal(taskId, decision, reason);
      }
      return submitAuthorReviewInternal(taskId, decision, reason);
    },
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({
        queryKey: ['board', String(vars.projectId), vars.audience],
      });
      queryClient.invalidateQueries({
        queryKey: taskActivityQueryKey(vars.taskId),
      });
    },
  });
}
